import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bold",
  "use": "icon-bold-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-bold\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M9.5,11.1h3.2c1,0,1.8-0.8,1.8-1.8c0,0,0,0,0,0c0-1-0.8-1.8-1.8-1.8c0,0,0,0,0,0H9.5L9.5,11.1z\nM15.8,17c-0.6,0.6-1.4,1-2.3,1H8V6h4.7C14.6,6,16,7.5,16,9.3c0,0.9-0.3,1.7-0.9,2.3c1,0.6,1.6,1.4,1.6,2.8C16.8,15.2,16.5,16.2,15.8,17zM9.5,12.6v3.8h4c1,0,1.8-0.7,1.8-1.7c0.1-1-0.6-1.9-1.6-2.1c-0.1,0-0.2,0-0.2,0L9.5,12.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol